import React from 'react';
import times from 'lodash/times';
import {
  UserActivityDay,
  UserActivityDayTitle,
  UserActivityHeader,
  UserActivityPageTitle,
  UserActivities,
} from './UserActivityStyles';
import LoadingMask from '../CommonComponents/LoadingMask';
import { UserActivityItemLoading } from './components/UserActivityItem/UserActivityItemLoading';

interface Props {}

export const UserActivityLoading: React.FC<Props> = () => {
  return (
    <div>
      <UserActivityHeader>
        <UserActivityPageTitle>
          <LoadingMask width="150px" height="24px" isDark />
        </UserActivityPageTitle>
        <LoadingMask width="164px" height="48px" isDark />
      </UserActivityHeader>

      <UserActivityDay>
        <UserActivityDayTitle>
          <LoadingMask width="100px" height="24px" isDark />
        </UserActivityDayTitle>
        <UserActivities>
          {times(4).map(key => (
            <UserActivityItemLoading key={key} />
          ))}
        </UserActivities>
      </UserActivityDay>
    </div>
  );
};
